import React from "react";
import Image from '../Image';
import Icon from '@mui/material/Icon';
import { makeStyles} from "@mui/styles";
import Tooltip from '@common/ToolTip';

const useStyles = makeStyles(theme => ({
    svgIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '&.pointer':{
            cursor:'pointer'
        },
        '& img':{
            maxWidth:24
        },
        '&.s-50x':{
            width:'0.50em',
            height:'0.50em',
            '& img':{
                maxWidth:11
            }
        },
        '&.s-75x':{
            width:'0.75em',
            height:'0.75em',
            '& img':{
                maxWidth:15
            }
        },
        '&.s-125x':{
            width:'1.5em',
            height:'1.5em'
        },
        '&.s-150x':{
            width:'1.5em',
            height:'1.5em',
            '& img':{
                maxWidth:32
            }
        },
        '&.s-200x':{
            width:'2em',
            height:'2em',
            '& img':{
                maxWidth:40
            }
        },
        '&.m-4':{
            margin:4
        },
        '&.mr-4':{
            marginRight:4
        },
        '&.ml-4':{
            marginLeft:4
        },
        '&.m-6':{
            margin:6
        },
        '&.mr-6':{
            marginRight:6
        },
        '&.ml-6':{
            marginLeft:6
        },
        '&.m-8':{
            margin:8
        },
        '&.mr-8':{
            marginRight:8
        },
        '&.ml-8':{
            marginLeft:8
        },
        
  }
}));

const sizeClass = {mini:'s-50x',small:'s-75x',normal:'s-100x',medium:'s-125x',large:'s-150x','extra-large':'s-200x'}
const SvgIcon = ({icon,className='',size="large",onClick=null,toolTip,...others})=>{
    const classes = useStyles();
    const WithToolTip = ({children})=>toolTip?<Tooltip {...toolTip}>{children}</Tooltip>:children
    return icon?<WithToolTip><Icon className={`${classes.svgIcon} svgIcon ${className} ${sizeClass[size] || ''} ${onClick?'pointer':''}`} onClick={onClick} {...others}><Image src={icon}/></Icon></WithToolTip>:''

}

export default SvgIcon;